<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Recherche dispositif médical</div>
        <div class="modal-body">
            <ng-container *ngIf="formGroup">
                <frg-form-input label="Recherche par libelle LPP" id="libelleLpp" type="text"
                    [formGroup]="formGroup" [control]="formGroup.get('libelleLpp')" #libelleLpp>
                </frg-form-input>

                <div *ngIf="listLppTemplate && listLppTemplate.length > 0; then listLpps else noLpps"></div>
                <ng-template #listLpps>
                    <frg-form-input label="Résultat LPP" id="codeLpp" type="ngSelect"
                        [formGroup]="formGroup" [control]="formGroup.get('codeLpp')"
                        [selectValue]="listLppTemplate" [required]="true">
                    </frg-form-input>
                    <span class="input-info">Veuillez sélectionner un LPP de cette liste</span>
                </ng-template>
                <ng-template #noLpps>
                    <div class="no-lpp-result" *ngIf="isLppSearchResultMessageDisplay">
                        Aucun LPP trouvé
                    </div>
                </ng-template>

                <div *ngIf="isListProduitsExists(); then listProduits else noProduits"></div>
                <ng-template #listProduits>
                    <frg-form-input label="Produits liés à ce LPP" id="idProduit" type="ngSelect"
                        [formGroup]="formGroup" [control]="formGroup.get('idProduit')"
                        [selectValue]="getListProduits()">
                    </frg-form-input>
                    <span class="input-info">Pour plus de précisions vous pouvez sélectionner un produit de cette liste</span>
                </ng-template>
                <ng-template #noProduits>
                    <div class="no-lpp-result" *ngIf="isLppSearchResultMessageDisplay">
                        Aucun produit trouvé pour le LPP sélectionné
                    </div>
                </ng-template>

                <div class="buttons-wrapper">
                    <frg-button [type]="'button'" [backgroundColor]="'var(--darkest-primary)'" (activated)="closeModal()">Annuler</frg-button>
                    <frg-button [type]="'button'" (activated)="validerSelection()" [disabled]="!formGroup.valid">Valider</frg-button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div class="modal-background"></div>